import { Component } from "@angular/core";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { AuthService } from "@ponder-core/auth/auth.service";
import { NavigationService } from "@ponder-core/navigation/navigation.service";

@Component({
    selector: "overauthorized",
    imports: [],
    template: ""
})
export class OverauthorizedComponent {
    public constructor(private authService: AuthService, private navigation: NavigationService) {

    }

    public ngOnInit(): void {
        this.authService.getSessionAsync().then((authSession?: AuthSession) => {
            if (authSession?.username?.length) {
                this.navigation.back(authSession.username);
            }
        });
    }
}